import { render, staticRenderFns } from "./wxpacket.vue?vue&type=template&id=36ed8ee2&scoped=true"
import script from "./wxpacket.vue?vue&type=script&lang=js"
export * from "./wxpacket.vue?vue&type=script&lang=js"
import style0 from "./wxpacket.vue?vue&type=style&index=0&id=36ed8ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed8ee2",
  null
  
)

export default component.exports